// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "service_stock_clip".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "service_stock_clip" table (1:1 with a DB row, on the wire). */
export const serviceStockClipAtomSchema = z.object({
    id: z.string(),
    organizationServiceId: z.string(),
    stockClipId: z.string(),
    rank: z.number(),
    score: z.number().nullable(),
    isPinned: z.boolean(),
    resolvedAt: z.string().datetime(),
});
//# sourceMappingURL=serviceStockClip.js.map